export const today = () => {
  const today = new Date();
  let dd = today.getDate().toString();
  let mm = (today.getMonth() + 1).toString();
  let yyyy = today.getFullYear().toString();
  if (+dd < 10) {
    dd = "0" + dd;
  }
  if (+mm < 10) {
    mm = "0" + mm;
  }

  return `${dd}.${mm}.${yyyy}`;
};

export const validate = (values) => {
  const currentYear = today().slice(-4);
  const errors: any = { user: {}, userData: {} };
  if (!values.userData.name) {
    errors.userData.name = "Обязательное поле";
  }
  // if (!values.userData.surname) {
  //   errors.userData.surname = "Обязательное поле";
  // }
  // if (!values.userData.thirdname) {
  //   errors.userData.thirdname = "Обязательное поле";
  // }
  if (values.userData.birth_date) {
    if (parseInt(currentYear) - parseInt(values.userData.birth_date) < 18) {
      errors.userData.birth_date = "Должно быть больше 18 лет";
    }
  } else {
    errors.userData.birth_date = "Обязательное поле";
  }
  if (!values.user.phone) {
    errors.user.phone = "Обязательное поле";
  }
  if (
    !(
      parseInt(currentYear) - parseInt(values.userData.birth_date) >
      parseInt(values.userData.driver_experience)
    )
  ) {
    // errors.userData.driver_experience = "Неверное значение";
  }
  if (values.user.email) {
    const re = /\S+@\S+\.\S+/;
    if (!re.test(values.user.email)) {
      errors.user.email = "Неверный формат почты";
    }
  }
  return errors;
};

const deep_value = function (obj, path) {
  for (var i = 0, path = path.split("."), len = path.length; i < len; i++) {
    obj = obj[path[i]];
  }
  return obj;
};

export const handleLink = (name, values) => {
  const url = deep_value(values, name);
  const link_url = document.createElement("a");
  link_url.download = url.substring(url.lastIndexOf("/") + 1, url.length);
  link_url.href = process.env.REACT_APP_API_URL + "/" + url;
  document.body.appendChild(link_url);
  link_url.setAttribute("target", "_blank");
  link_url.click();
  document.body.removeChild(link_url);
};

export const isDisabled = (name, values) => {
  const [obj, field] = name.split(".");
  return !values[obj][field];
};

export const destructure = (name, values) => {
  const [obj, field] = name.split(".");
  return values[obj][field];
};

type TFields = {
  first_block: {
    id: number;
    name: string;
    placeholder: string;
    label: string;
    pattern?: string;
    type: string;
  }[];
  second_block: {
    id: number;
    name: string;
    placeholder: string;
    label: string;
    type: string;
  }[];
  documents: {
    first_row: {
      id: number;
      name: string;
      label: string;
      area: string;
    }[];
  };
};

export const fields: TFields = {
  first_block: [
    {
      id: 1,
      name: "userData.name",
      placeholder: "Имя",
      label: "Имя",
      type: "text",
    },
    // {
    //   id: 2,
    //   name: "userData.surname",
    //   placeholder: "Фамилия",
    //   label: "Фамилия",
    //   type: "text",
    // },
    // {
    //   id: 3,
    //   name: "userData.thirdname",
    //   placeholder: "Отчество",
    //   label: "Отчество",
    //   type: "text",
    // },
    {
      id: 6,
      name: "user.email",
      placeholder: "Email",
      label: "Email",
      type: "text",
    },
    {
      id: 7,
      name: "userData.driver_experience",
      placeholder: "Стаж вождения (лет)",
      label: "Стаж вождения (лет)",
      type: "number",
    },
    {
      id: 5,
      name: "user.phone",
      placeholder: "Телефон",
      label: "Телефон",
      type: "text",
    },
    {
      id: 4,
      name: "userData.birth_date",
      placeholder: "Дата рождения",
      label: "Дата рождения",
      pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}",
      type: "date",
    },
    {
      id: 8,
      name: "userData.security_check",
      placeholder: "Проверка СБ",
      label: "Проверка СБ",
      type: "select",
    },
  ],
  second_block: [
    {
      id: 10,
      name: "userData.deposit_balance",
      placeholder: "Депозит",
      label: "Депозит",
      type: "text",
    },
    {
      id: 11,
      name: "userData.balance",
      placeholder: "Баланс бонусной программы",
      label: "Баланс бонусной программы",
      type: "text",
    },
  ],
  documents: {
    first_row: [
      {
        id: 12,
        name: "userData.passport_first_page",
        label: "Паспорт 1 страница",
        area: "a",
      },
      {
        id: 13,
        name: "userData.passport_second_page",
        label: "Паспорт 2 страница",
        area: "b",
      },
      {
        id: 14,
        name: "userData.driver_license_first_page",
        label: "В/У 1 страница",
        area: "d",
      },
      {
        id: 15,
        name: "userData.driver_license_second_page",
        label: "В/У 2 страница",
        area: "e",
      },
      {
        id: 16,
        name: "userData.selfie",
        label: "Селфи арендатора",
        area: "c",
      },
    ],
  },
};

type TColumn = {
  id: number;
  label: string;
};

export const tabs: TColumn[] = [
  {
    id: 0,
    label: "Основная информация",
  },
  {
    id: 1,
    label: "Избранные автомобили",
  },
  {
    id: 2,
    label: "Поездки",
  },
  {
    id: 2,
    label: "Награды и статусы",
  },
];

export const tripFields: TColumn[] = [
  {
    id: 0,
    label: "Даты",
  },
  { id: 1, label: "Автомобиль" },
  { id: 2, label: "Клиент" },
  { id: 3, label: "Сумма" },
  { id: 4, label: "Действия" },
];

export const favoriteColumn: TColumn[] = [
  {
    id: 0,
    label: "ID",
  },
  { id: 1, label: "Автомобиль" },
];
